import { AxiosError } from "axios"
import { createAsyncThunkCustom } from "store/hooks"
import { getLabelOrderProduct, postLabelOrder } from "../api/bikeLabelOrderApi"
import { orderFormatBodyPostSelector } from "./bikeLabelOrderSelectors"
import { isNotEmpty } from "utils"

// Thunk for get label product
export const getLabelOrderProductThunk = createAsyncThunkCustom(
	"bikeLabelOrder/getLabelOrder",
	async (_, { rejectWithValue }) => {
		try {
			const { res: labelProductsList, getError } = await getLabelOrderProduct()
			if (getError() || !isNotEmpty(labelProductsList)) throw getError()
			return labelProductsList
		} catch (err) {
			const error = err as unknown as AxiosError
			return rejectWithValue(error.message)
		}
	}
)

export const postLabelOrderThunk = createAsyncThunkCustom(
	"bikeLabelOrder/postOrderCommand",
	async (_, { rejectWithValue, getState }) => {
		const state = getState()
		const orderBody = orderFormatBodyPostSelector(state)
		try {
			const { res: labelProductsList, getError } = await postLabelOrder(orderBody)
			if (getError() || !labelProductsList) throw getError()
			return labelProductsList
		} catch (err) {
			const error = err as unknown as AxiosError
			return rejectWithValue(error.message)
		}
	}
)
